export default __webpack_public_path__ + "static/media/india-soft-2020.ed6878c3.png";